export const tagEvent = (event: string, params) => {
  const payload = {
    event,
    ...params,
  };
  if (typeof window !== 'undefined') {
    window['dataLayer'] = window['dataLayer'] || [];
    window['dataLayer'].push(payload);
  }
};

export const set = (item: string, params) => {
  if ('gtag' in window) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.gtag('set', item, params);
  }
};
